const pEncodeDecodeConfig = {
  singleQuotation: { decoded: `'`, encoded: "P1$" },
  doubleQuotation: { decoded: `"`, encoded: "P2$" },
};

export const removeEncodeDecodeParts = (str) => {
  let returnedStr = str;
  if (str) {
    for (const each in pEncodeDecodeConfig) {
      returnedStr = returnedStr.replaceAll(pEncodeDecodeConfig[each].decoded, "");
    }
  }
  return returnedStr;
};
export const pStringDecoder = (str) => {
  let returnedStr = str;
  if (str) {
    for (const each in pEncodeDecodeConfig) {
      returnedStr = returnedStr.replaceAll(
        pEncodeDecodeConfig[each].encoded,
        pEncodeDecodeConfig[each].decoded
      );
    }
  }
  return returnedStr;
};

export const pStringEncoder = (str) => {
  let returnedStr = str;
  if (str) {
    for (const each in pEncodeDecodeConfig) {
      returnedStr = returnedStr.replaceAll(
        pEncodeDecodeConfig[each].decoded,
        pEncodeDecodeConfig[each].encoded
      );
    }
  }
  return returnedStr;
};
